import React from "react";
import {
  Navbar,
  Nav,
  Input,
  InputGroup,
  InputGroupText,
  Form,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
const moment = require("moment");

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  changeLanguage(value) {
    this.props.container.localeManager.changeLanguage(value);
    window.location.reload();
  }

  render() {
    return (
      <>
        <footer
          className="site-footer px-4 pt-3 shadow"
          style={{ paddingBottom: 100 }}
        >
          <div className="d-flex align-items-center flex-wrap gap-3">
            {/* Premium CTA */}
            {!this.props.container.dataService.data.enablePremiumFeature() && (
              <Link className="footer-premium-cta" to="/premium">
                <FontAwesomeIcon icon="star" className="mx-0" />
                Go Premium
              </Link>
            )}

            {/* Links */}
            <a
              href="https://truckyapp.com"
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon fixedWidth className="me-1" icon="globe" />
              truckyapp.com
            </a>
            <a
              href="https://truckyapp.com/client"
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon fixedWidth className="me-1" icon="download" />
              Download
            </a>
            <a
              href="https://truckyapp.com/platform-terms-and-conditions/"
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon fixedWidth className="me-1" icon="file" />
              Terms
            </a>
            <a
              href="https://truckyapp.com/platform-privacy-policy/"
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon fixedWidth className="me-1" icon="file" />
              Privacy
            </a>
            <a
              href="https://truckyapp.com/cookie-policy/"
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon fixedWidth className="me-1" icon="cookie" />
              Cookie
            </a>
            <a
              href="https://truckyapp.com/kb"
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon fixedWidth className="me-1" icon="life-ring" />
              {this.props.container.localeManager.strings.knowledgeBase}
            </a>

            {/* Social + Language on the right */}
            <div className="d-flex align-items-center gap-2 ms-auto flex-wrap">
              <div className="footer-social d-flex gap-2">
                <a
                  href="https://truckyapp.com/discord"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-icon"
                >
                  <FontAwesomeIcon
                    fixedWidth
                    className="mx-0"
                    icon={["fab", "discord"]}
                  />
                </a>
                <a
                  href="https://www.twitch.tv/truckyapp"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-icon"
                >
                  <FontAwesomeIcon
                    fixedWidth
                    className="mx-0"
                    icon={["fab", "twitch"]}
                  />
                </a>
                <a
                  href="https://truckyapp.com/twitter"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-icon"
                >
                  <FontAwesomeIcon
                    fixedWidth
                    className="mx-0"
                    icon={["fab", "twitter"]}
                  />
                </a>
                <a
                  href="https://www.youtube.com/c/trucky"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-icon"
                >
                  <FontAwesomeIcon
                    fixedWidth
                    className="mx-0"
                    icon={["fab", "youtube"]}
                  />
                </a>
                <a
                  href="https://github.com/Trucky"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-social-icon"
                >
                  <FontAwesomeIcon
                    fixedWidth
                    className="mx-0"
                    icon={["fab", "github"]}
                  />
                </a>
              </div>
              <div className="footer-lang">
                <InputGroup size="sm">
                  <InputGroupText>
                    <FontAwesomeIcon icon="language" className="mx-0" />
                  </InputGroupText>
                  <Input
                    onChange={(e) => this.changeLanguage(e.target.value)}
                    defaultValue={this.props.container.localeManager.language}
                    type="select"
                    style={{ minWidth: 120 }}
                  >
                    {this.props.container.localeManager.availableLanguages.map(
                      (l) => (
                        <option key={l.code} value={l.code}>
                          {l.displayName}
                        </option>
                      ),
                    )}
                  </Input>
                </InputGroup>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <span className="footer-credit small">
              Made with{" "}
              <FontAwesomeIcon icon="heart" className="me-0 text-danger" /> by
              Trucky
            </span>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
